import { jsx as u, jsxs as A } from "react/jsx-runtime";
import * as s from "react";
import { c as J, b as g, a as Q } from "../index-Dn5fq5RO.js";
import { u as S } from "../index-BwdHfdWj.js";
import { c as G, A as Z, D as ee, C as te, a as oe, R as re, P as ne } from "../index-DpS21AEH.js";
import { u as se } from "../index-_igB3qdS.js";
import { P as F } from "../index-C7ixzbBF.js";
import { P as j } from "../index-Bo0P2KXg.js";
import { a as ae } from "../index-DK6lfaz2.js";
var ie = "VisuallyHidden", V = s.forwardRef(
  (e, o) => /* @__PURE__ */ u(
    j.span,
    {
      ...e,
      ref: o,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...e.style
      }
    }
  )
);
V.displayName = ie;
var le = V, [_, je] = J("Tooltip", [
  G
]), D = G(), B = "TooltipProvider", ce = 700, L = "tooltip.open", [ue, M] = _(B), U = (e) => {
  const {
    __scopeTooltip: o,
    delayDuration: t = ce,
    skipDelayDuration: r = 300,
    disableHoverableContent: n = !1,
    children: i
  } = e, [c, v] = s.useState(!0), a = s.useRef(!1), p = s.useRef(0);
  return s.useEffect(() => {
    const l = p.current;
    return () => window.clearTimeout(l);
  }, []), /* @__PURE__ */ u(
    ue,
    {
      scope: o,
      isOpenDelayed: c,
      delayDuration: t,
      onOpen: s.useCallback(() => {
        window.clearTimeout(p.current), v(!1);
      }, []),
      onClose: s.useCallback(() => {
        window.clearTimeout(p.current), p.current = window.setTimeout(
          () => v(!0),
          r
        );
      }, [r]),
      isPointerInTransitRef: a,
      onPointerInTransitChange: s.useCallback((l) => {
        a.current = l;
      }, []),
      disableHoverableContent: n,
      children: i
    }
  );
};
U.displayName = B;
var O = "Tooltip", [de, R] = _(O), Y = (e) => {
  const {
    __scopeTooltip: o,
    children: t,
    open: r,
    defaultOpen: n = !1,
    onOpenChange: i,
    disableHoverableContent: c,
    delayDuration: v
  } = e, a = M(O, e.__scopeTooltip), p = D(o), [l, f] = s.useState(null), m = se(), d = s.useRef(0), h = c ?? a.disableHoverableContent, T = v ?? a.delayDuration, y = s.useRef(!1), [x = !1, C] = Q({
    prop: r,
    defaultProp: n,
    onChange: (H) => {
      H ? (a.onOpen(), document.dispatchEvent(new CustomEvent(L))) : a.onClose(), i == null || i(H);
    }
  }), b = s.useMemo(() => x ? y.current ? "delayed-open" : "instant-open" : "closed", [x]), P = s.useCallback(() => {
    window.clearTimeout(d.current), d.current = 0, y.current = !1, C(!0);
  }, [C]), E = s.useCallback(() => {
    window.clearTimeout(d.current), d.current = 0, C(!1);
  }, [C]), N = s.useCallback(() => {
    window.clearTimeout(d.current), d.current = window.setTimeout(() => {
      y.current = !0, C(!0), d.current = 0;
    }, T);
  }, [T, C]);
  return s.useEffect(() => () => {
    d.current && (window.clearTimeout(d.current), d.current = 0);
  }, []), /* @__PURE__ */ u(re, { ...p, children: /* @__PURE__ */ u(
    de,
    {
      scope: o,
      contentId: m,
      open: x,
      stateAttribute: b,
      trigger: l,
      onTriggerChange: f,
      onTriggerEnter: s.useCallback(() => {
        a.isOpenDelayed ? N() : P();
      }, [a.isOpenDelayed, N, P]),
      onTriggerLeave: s.useCallback(() => {
        h ? E() : (window.clearTimeout(d.current), d.current = 0);
      }, [E, h]),
      onOpen: P,
      onClose: E,
      disableHoverableContent: h,
      children: t
    }
  ) });
};
Y.displayName = O;
var k = "TooltipTrigger", q = s.forwardRef(
  (e, o) => {
    const { __scopeTooltip: t, ...r } = e, n = R(k, t), i = M(k, t), c = D(t), v = s.useRef(null), a = S(o, v, n.onTriggerChange), p = s.useRef(!1), l = s.useRef(!1), f = s.useCallback(() => p.current = !1, []);
    return s.useEffect(() => () => document.removeEventListener("pointerup", f), [f]), /* @__PURE__ */ u(Z, { asChild: !0, ...c, children: /* @__PURE__ */ u(
      j.button,
      {
        "aria-describedby": n.open ? n.contentId : void 0,
        "data-state": n.stateAttribute,
        ...r,
        ref: a,
        onPointerMove: g(e.onPointerMove, (m) => {
          m.pointerType !== "touch" && !l.current && !i.isPointerInTransitRef.current && (n.onTriggerEnter(), l.current = !0);
        }),
        onPointerLeave: g(e.onPointerLeave, () => {
          n.onTriggerLeave(), l.current = !1;
        }),
        onPointerDown: g(e.onPointerDown, () => {
          p.current = !0, document.addEventListener("pointerup", f, { once: !0 });
        }),
        onFocus: g(e.onFocus, () => {
          p.current || n.onOpen();
        }),
        onBlur: g(e.onBlur, n.onClose),
        onClick: g(e.onClick, n.onClose)
      }
    ) });
  }
);
q.displayName = k;
var I = "TooltipPortal", [pe, fe] = _(I, {
  forceMount: void 0
}), W = (e) => {
  const { __scopeTooltip: o, forceMount: t, children: r, container: n } = e, i = R(I, o);
  return /* @__PURE__ */ u(pe, { scope: o, forceMount: t, children: /* @__PURE__ */ u(F, { present: t || i.open, children: /* @__PURE__ */ u(ne, { asChild: !0, container: n, children: r }) }) });
};
W.displayName = I;
var w = "TooltipContent", X = s.forwardRef(
  (e, o) => {
    const t = fe(w, e.__scopeTooltip), { forceMount: r = t.forceMount, side: n = "top", ...i } = e, c = R(w, e.__scopeTooltip);
    return /* @__PURE__ */ u(F, { present: r || c.open, children: c.disableHoverableContent ? /* @__PURE__ */ u($, { side: n, ...i, ref: o }) : /* @__PURE__ */ u(ve, { side: n, ...i, ref: o }) });
  }
), ve = s.forwardRef((e, o) => {
  const t = R(w, e.__scopeTooltip), r = M(w, e.__scopeTooltip), n = s.useRef(null), i = S(o, n), [c, v] = s.useState(null), { trigger: a, onClose: p } = t, l = n.current, { onPointerInTransitChange: f } = r, m = s.useCallback(() => {
    v(null), f(!1);
  }, [f]), d = s.useCallback(
    (h, T) => {
      const y = h.currentTarget, x = { x: h.clientX, y: h.clientY }, C = ye(x, y.getBoundingClientRect()), b = Te(x, C), P = Ce(T.getBoundingClientRect()), E = ge([...b, ...P]);
      v(E), f(!0);
    },
    [f]
  );
  return s.useEffect(() => () => m(), [m]), s.useEffect(() => {
    if (a && l) {
      const h = (y) => d(y, l), T = (y) => d(y, a);
      return a.addEventListener("pointerleave", h), l.addEventListener("pointerleave", T), () => {
        a.removeEventListener("pointerleave", h), l.removeEventListener("pointerleave", T);
      };
    }
  }, [a, l, d, m]), s.useEffect(() => {
    if (c) {
      const h = (T) => {
        const y = T.target, x = { x: T.clientX, y: T.clientY }, C = (a == null ? void 0 : a.contains(y)) || (l == null ? void 0 : l.contains(y)), b = !xe(x, c);
        C ? m() : b && (m(), p());
      };
      return document.addEventListener("pointermove", h), () => document.removeEventListener("pointermove", h);
    }
  }, [a, l, c, p, m]), /* @__PURE__ */ u($, { ...e, ref: i });
}), [he, me] = _(O, { isInside: !1 }), $ = s.forwardRef(
  (e, o) => {
    const {
      __scopeTooltip: t,
      children: r,
      "aria-label": n,
      onEscapeKeyDown: i,
      onPointerDownOutside: c,
      ...v
    } = e, a = R(w, t), p = D(t), { onClose: l } = a;
    return s.useEffect(() => (document.addEventListener(L, l), () => document.removeEventListener(L, l)), [l]), s.useEffect(() => {
      if (a.trigger) {
        const f = (m) => {
          const d = m.target;
          d != null && d.contains(a.trigger) && l();
        };
        return window.addEventListener("scroll", f, { capture: !0 }), () => window.removeEventListener("scroll", f, { capture: !0 });
      }
    }, [a.trigger, l]), /* @__PURE__ */ u(
      ee,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: i,
        onPointerDownOutside: c,
        onFocusOutside: (f) => f.preventDefault(),
        onDismiss: l,
        children: /* @__PURE__ */ A(
          te,
          {
            "data-state": a.stateAttribute,
            ...p,
            ...v,
            ref: o,
            style: {
              ...v.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ u(ae, { children: r }),
              /* @__PURE__ */ u(he, { scope: t, isInside: !0, children: /* @__PURE__ */ u(le, { id: a.contentId, role: "tooltip", children: n || r }) })
            ]
          }
        )
      }
    );
  }
);
X.displayName = w;
var K = "TooltipArrow", z = s.forwardRef(
  (e, o) => {
    const { __scopeTooltip: t, ...r } = e, n = D(t);
    return me(
      K,
      t
    ).isInside ? null : /* @__PURE__ */ u(oe, { ...n, ...r, ref: o });
  }
);
z.displayName = K;
function ye(e, o) {
  const t = Math.abs(o.top - e.y), r = Math.abs(o.bottom - e.y), n = Math.abs(o.right - e.x), i = Math.abs(o.left - e.x);
  switch (Math.min(t, r, n, i)) {
    case i:
      return "left";
    case n:
      return "right";
    case t:
      return "top";
    case r:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function Te(e, o, t = 5) {
  const r = [];
  switch (o) {
    case "top":
      r.push(
        { x: e.x - t, y: e.y + t },
        { x: e.x + t, y: e.y + t }
      );
      break;
    case "bottom":
      r.push(
        { x: e.x - t, y: e.y - t },
        { x: e.x + t, y: e.y - t }
      );
      break;
    case "left":
      r.push(
        { x: e.x + t, y: e.y - t },
        { x: e.x + t, y: e.y + t }
      );
      break;
    case "right":
      r.push(
        { x: e.x - t, y: e.y - t },
        { x: e.x - t, y: e.y + t }
      );
      break;
  }
  return r;
}
function Ce(e) {
  const { top: o, right: t, bottom: r, left: n } = e;
  return [
    { x: n, y: o },
    { x: t, y: o },
    { x: t, y: r },
    { x: n, y: r }
  ];
}
function xe(e, o) {
  const { x: t, y: r } = e;
  let n = !1;
  for (let i = 0, c = o.length - 1; i < o.length; c = i++) {
    const v = o[i].x, a = o[i].y, p = o[c].x, l = o[c].y;
    a > r != l > r && t < (p - v) * (r - a) / (l - a) + v && (n = !n);
  }
  return n;
}
function ge(e) {
  const o = e.slice();
  return o.sort((t, r) => t.x < r.x ? -1 : t.x > r.x ? 1 : t.y < r.y ? -1 : t.y > r.y ? 1 : 0), we(o);
}
function we(e) {
  if (e.length <= 1) return e.slice();
  const o = [];
  for (let r = 0; r < e.length; r++) {
    const n = e[r];
    for (; o.length >= 2; ) {
      const i = o[o.length - 1], c = o[o.length - 2];
      if ((i.x - c.x) * (n.y - c.y) >= (i.y - c.y) * (n.x - c.x)) o.pop();
      else break;
    }
    o.push(n);
  }
  o.pop();
  const t = [];
  for (let r = e.length - 1; r >= 0; r--) {
    const n = e[r];
    for (; t.length >= 2; ) {
      const i = t[t.length - 1], c = t[t.length - 2];
      if ((i.x - c.x) * (n.y - c.y) >= (i.y - c.y) * (n.x - c.x)) t.pop();
      else break;
    }
    t.push(n);
  }
  return t.pop(), o.length === 1 && t.length === 1 && o[0].x === t[0].x && o[0].y === t[0].y ? o : o.concat(t);
}
var be = U, Pe = Y, Ee = q, Re = W, _e = X, De = z;
const Oe = "_tooltip_1idlf_1", Ae = "_fadein_1idlf_1", Le = {
  tooltip: Oe,
  fadein: Ae
}, Ve = ({
  children: e,
  message: o,
  open: t,
  side: r
}) => /* @__PURE__ */ u(be, { delayDuration: 200, children: /* @__PURE__ */ A(Pe, { open: t, children: [
  /* @__PURE__ */ u(Ee, { asChild: !0, children: /* @__PURE__ */ u("span", { children: e }) }),
  /* @__PURE__ */ u(Re, { children: /* @__PURE__ */ A(
    _e,
    {
      side: r,
      className: Le.tooltip,
      sideOffset: 5,
      children: [
        o,
        /* @__PURE__ */ u(De, {})
      ]
    }
  ) })
] }) });
export {
  Ve as Tooltip
};
